module.exports = __webpack_public_path__ + "silk EMS logo 2.85df7fe.png";